import axios from "axios";
import React, { useState, useEffect } from "react";
import { logOut } from "./logOut";
import { useAppDispatch } from "../store";
import { useSnackbar } from "./SnackbarContext";

export default function AudioFragment({ id , type = 'prerecordedspeech' }: any) {

    const { showSnackbar } = useSnackbar();

    const dispatch = useAppDispatch()

    const [audio, setAudio] = useState('');

    async function getAudio() {

        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/${type}/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setAudio(response.data[0].audiofile);
                    
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    return (
        <audio preload='none' onPlay={() => getAudio()} style={{ height: '30px' }} controls>
            <source key={audio} src={"data:audio/mpeg;base64," + audio} />
        </audio>
    )
}
